import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  title: {
    fontSize: 18,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  valueContainer: {
    position: 'absolute',
    bottom: -32,
    left: '30%',
    right: '30%',
  },
  value: {
    fontSize: 18,
    fontWeight: 700,
    textTransform: 'uppercase',
    textAlign: 'center',
  },
}));
